import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

@Radium
export default class GetAWorkshop extends React.Component {
  render() {
    return (
      <div>
        <h4>Cesta k workshopu je snadná - zvládneme ho společně zařídit ve třech jednoduchých krocích.</h4>
        <ul style={styles.list}>
          <li style={styles.point}>
            <span style={styles.circle}><strong style={styles.circle.number}>1</strong></span>
            <h3 style={styles.heading}>Vyberte si workshop z naší nabídky</h3>
            Nabízíme možnost uspořádat workshopy jednotlivě, nebo se můžete stát pilotní školou a my u Vás během školního roku uskutečníme všechny naše workshopy.
          </li>
          <li style={styles.point}>
            <span style={styles.circle}><strong style={styles.circle.number}>2</strong></span>
            <h3 style={styles.heading}>Napište nám a navrhněte 3 termíny</h3>
            Budeme od Vás potřebovat několik údajů, bez nich se neobejdeme.
          </li>
          <li style={[styles.point, styles.point.last]}>
            <span style={styles.circle}><strong style={styles.circle.number}>3</strong></span>
            <h3 style={styles.heading}>My se vám co nejdříve ozveme s podrobnostmi</h3>
            A to je vše, o zbytek se postaráme my.
          </li>
        </ul>
        <Link style={styles.cta} to="/objednavka/workshopy" className="btn btn-primary btn-lg">Vytvořit objednávku</Link>
      </div>
    );
  }
}

const styles = {
  list: {
    listStyle: 'none',
    paddingLeft: 15,
    marginTop: 20
  },
  point: {
    borderLeft: '2px solid #5d9f51',
    paddingLeft: 45,
    paddingBottom: '3em',
    position: 'relative',
    minHeight: 116,
    last: {
      borderLeft: '2px solid transparent'
    }
  },
  heading: {
    fontSize: 20,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 6,
    paddingBottom: 6
  },
  circle: {
    border: '2px solid #5d9f51',
    borderRadius: '100%',
    width: 41,
    height: 41,
    padding: 6,
    color: '#5d9f51',
    fontSize: 26,
    position: 'absolute',
    left: -21,
    textAlign: 'center',
    top: 0,
    backgroundColor: '#FFF',
    number: {
      display: 'block',
      marginTop: '-0.25em'
    }
  },
  cta: {
    marginLeft: 60,
    backgroundColor: '#5d9f51',
    borderColor: '#5d9f51'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/get_a_workshop/index.jsx